export default function checkIfMobile(mobileBreakpoint = 1024) {
  return window.innerWidth < mobileBreakpoint;
}
